import { AxiosRequestConfig, GenericAbortSignal } from 'axios'
import { API_APPLICANT_URL, API_TAEKWANG_URL } from '../constants/base-urls'
import type {
  ICandidate,
  ICandidateByApplicant,
  ICandidateHistories,
  ICandidateToCreateEmployee,
  IDocumentPreviewItem,
  IPaginationParam,
  IPaginationResponse,
} from '../types'
import { createAxiosInstance } from '../utils'

const axios = createAxiosInstance({
  baseURL: API_TAEKWANG_URL,
  withAuth: true,
})

const axiosTaekwang = createAxiosInstance({
  baseURL: API_TAEKWANG_URL,
  withAuth: true,
})

const axiosApplicant = createAxiosInstance({
  baseURL: API_APPLICANT_URL,
  withAuth: true,
})

type FetchCandidateParams = {
  education?: string
  position?: string
  province?: string
  vacancyId?: string
  name?: string
  educationId?: string
  experience?: string | number
  age?: number
  domicile?: string
  startAt?: string
  endAt?: string
  type?: string
} & IPaginationParam

export type ExportStatus = 'PENDING' | 'PROCESSING' | 'SUCCESS' | 'FAILED'

export interface ExportRow {
  file?: string | null
  email: string
  status: ExportStatus
  type: string
  oid: string
  createdAt?: string
  chunk: number | null
  totalChunk: number | null
}

export interface Page<T> {
  content: T[]
  totalElements: number
  totalPages: number
  number: number
  size: number
}

export interface ListExportsParams {
  page?: number
  size?: number
  type?: string
}

export const fetchPool = (params?: FetchCandidateParams, signal?: GenericAbortSignal) => {
  return axiosTaekwang
    .get<{ data: IPaginationResponse<ICandidate> }>(`/candidate`, { params, signal })
    .then((response) => response.data.data)
}
export const fetchCandidateStatistic = (params?: FetchCandidateParams, signal?: GenericAbortSignal) => {
  return axiosTaekwang
    .get<{ data: IPaginationResponse<ICandidate> }>(`/candidate/card`, { params, signal })
    .then((response) => response.data.data)
}

// export const fetchCandidate = (id: string, config?: AxiosRequestConfig) => {
//   return axiosTaekwang.get<{ data: ICandidate }>(`/candidate/profile/${id}`, config).then((response) => response.data.data)
// }

export const fetchCandidate = (id: string, config?: AxiosRequestConfig) => {
  return axiosTaekwang.get<{ data: ICandidate }>(`/candidate/${id}`, config).then((response) => response.data.data)
}

export const downloadCandidate = (payload: Record<string, any>) => {
  return axios
    .get(`/candidate/export`, {
      params: payload,
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      return response
    })
}

// export const downloadCandidateWithDateRange = (payload: FetchCandidateParams) => {
//   return axios
//     .post(
//       '/export',
//       {
//         type: payload.type,
//         startAt: payload.startAt,
//         endAt: payload.endAt,
//       },
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       },
//     )
//     .then((res) => res.data)
// }

export const downloadCandidateWithDateRange = (payload: FetchCandidateParams) => {
  return axios.post(
    '/export',
    {
      type: payload.type,
      startAt: payload.startAt,
      endAt: payload.endAt,
      vacancyId: payload.vacancyId,
    },
    {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 60000,
    },
  )
}

export const listExport = (): Promise<Page<ExportRow>> => {
  return axios.get<{ data: Page<ExportRow> }>('/export').then((res) => res.data.data)
}

export const fetchCandidateToCreateEmployeeByApplicanId = (oid: string, config?: AxiosRequestConfig) => {
  return axios.get<{ data: ICandidateToCreateEmployee }>(`/candidate/${oid}`, config).then((response) => response.data.data)
}

export const fetchCandidateByApplicantId = (oid: string, config?: AxiosRequestConfig) => {
  return axiosTaekwang.get<{ data: ICandidateByApplicant }>(`/candidate/${oid}`, config).then((response) => response.data.data)
}

export const fetchDetailCandidate = (oid?: string, signal?: GenericAbortSignal) => {
  return axiosTaekwang.get<{ data: ICandidateHistories }>(`/candidate/history/${oid}`, { signal }).then((response) => response.data.data)
}

// export const reminderUploadResume = (oid: string | undefined) => {
//   return axios.get<{ data: ICandidate }>(`candidate/profile/${oid}/reminder`).then((response) => response.data.data)
// }

export const reminderUploadResume = (oid: string | undefined) => {
  return axios.post<{ data: ICandidate }>(`candidate/${oid}/reminders/complete-profile`).then((response) => response.data.data)
}

export const offerCandidateExplore = (payload: Record<string, any>) => {
  return axiosApplicant.post(`/applicant/offer`, payload).then((response) => response.data)
}

// export const uploadResumeCandidate = async (payload: Record<string, any>) => {
//   return axios.post<{ data: { user: ICandidate } }>('/candidate/upload-resume', payload).then(({ data }) => data)
// }

export const uploadResumeCandidate = async (payload: Record<string, any>) => {
  console.log(payload)
  return axiosTaekwang.post<{ data: { user: ICandidate } }>('/candidate/upload-resume', payload).then(({ data }) => data)
}

export const completeCandidateProfile = (candidateId: string) => {
  return axios.post(`/candidate/${candidateId}/reminders/complete-profile`).then(({ data }) => data)
}

export const previewDocumentRequestGuest = (candidateId: string, config?: AxiosRequestConfig) => {
  return axiosTaekwang
    .get<{ data: IDocumentPreviewItem[] }>(`/candidate/document/${candidateId}`, {
      headers: { Accept: 'application/json, */*' },
      ...config,
    })
    .then((res) => res.data.data)
}

export const previewDocumentRequest = (candidateId: string, config?: AxiosRequestConfig) => {
  return axiosTaekwang.get<Blob>(`/candidate/document/${candidateId}`, {
    responseType: 'blob',
    headers: { Accept: 'application/pdf, application/json, */*' },
    ...config,
  })
}
